
import {Component, Prop, Vue} from "vue-property-decorator";
import LoyaltyBonusAddForm from "@/form/loyalty/loyaltyBonus/LoyaltyBonusAddForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
@Component({
  components: {FormGroup}
})
export default class LoyaltyBonusAddComponent extends Vue {
  @Prop() readonly form!: LoyaltyBonusAddForm;
}
